import { useState, useEffect } from "react";
import { useLang } from "../../i18n/LanguageContext";
import { scrollToSection } from "../utils/scrollToSection";
import { trackPageView } from "../utils/analytics";

export default function Header() {
  const { t, lang, toggleLang,  } = useLang();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { href: "#hero",      label: t.nav.home,     page: "Hero" },
    { href: "#about",     label: t.nav.about,    page: "About" },
    { href: "#services",  label: t.nav.services, page: "Services" },
    { href: "#projects",  label: t.nav.projects, page: "Projects" },
    { href: "#partners",  label: t.nav.partners, page: "Partners" },
    { href: "#downloads", label: t.nav.downloads, page: "Downloads" },
    { href: "#contact",   label: t.nav.contact,  page: "Contact" },
  ];
  const dashboardLabel = lang === "ar" ? "لوحة التحكم" : "Dashboard";

  return (
    <header className={`fixed top-0 w-full z-40 border-b border-white/5 transition-all duration-500 ${scrolled ? "bg-[#111112]/95 backdrop-blur-md" : "bg-transparent backdrop-blur-sm"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection("#hero"); }} className="flex items-center gap-2 group select-none mr-16">
          <img src="/logo.png" alt="Integrated Solutions Logo" className="h-12 sm:h-14 w-auto group-hover:opacity-90 transition-opacity" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8 text-[11px] font-black tracking-widest uppercase flex-nowrap">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => { e.preventDefault(); scrollToSection(l.href); trackPageView(l.page); }}
              className="text-zinc-400 hover:text-[#F28C18] transition-colors relative whitespace-nowrap after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[2px] after:bg-[#F28C18] hover:after:w-full after:transition-all">
              {l.label}
            </a>
          ))}
        </nav>

        {/* Right: Lang toggle + CTA + Hamburger */}
        <div className="flex items-center gap-3">
          <button onClick={toggleLang}
            className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded border border-white/10 text-[10px] font-black tracking-widest uppercase text-zinc-400 hover:text-[#F28C18] hover:border-[#F28C18]/40 transition-all">
            <i className="fas fa-globe text-[#F28C18]"></i>
            {lang === "en" ? "عربي" : "EN"}
          </button>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); trackPageView("Contact"); }} className="hidden sm:inline-flex px-5 py-2.5 bg-[#F28C18] text-black text-[10px] font-black tracking-widest uppercase rounded hover:bg-white transition-all duration-300">
            {t.hero.cta1}
          </a>
          <a href="/dashboard" onClick={() => trackPageView("Dashboard")} className="hidden sm:inline-flex px-4 py-2 border border-white/10 text-[10px] font-black tracking-widest uppercase rounded text-zinc-200 hover:text-[#F28C18] hover:border-[#F28C18]/40 transition-all">
            <i className="fas fa-tachometer-alt mr-2 text-sm"></i>
            {dashboardLabel}
          </a>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden text-white p-2" aria-label="Toggle menu">
            <i className={`fas ${menuOpen ? "fa-times" : "fa-bars"} text-lg`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-[#111112]/98 backdrop-blur-md border-t border-white/5 px-6 py-5 space-y-1">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => { e.preventDefault(); scrollToSection(l.href); trackPageView(l.page); setMenuOpen(false); }}
              className="block text-[11px] font-black tracking-widest uppercase text-zinc-400 hover:text-[#F28C18] transition-colors py-2.5 border-b border-white/5 whitespace-nowrap">
              {l.label}
            </a>
          ))}
          <div className="flex gap-3 pt-4">
            <button onClick={toggleLang}
              className="flex-1 py-2.5 rounded border border-white/10 text-[10px] font-black tracking-widest uppercase text-zinc-400 hover:text-[#F28C18] transition-all">
              <i className="fas fa-globe mr-1 text-[#F28C18]"></i>{lang === "en" ? "عربي" : "EN"}
            </button>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); trackPageView("Contact"); setMenuOpen(false); }}
              className="flex-1 py-2.5 bg-[#F28C18] text-black text-[10px] font-black tracking-widest uppercase rounded text-center hover:bg-white transition-all">
              {t.hero.cta1}
            </a>
            <a href="/dashboard" onClick={() => { trackPageView("Dashboard"); setMenuOpen(false); }}
              className="flex-1 py-2.5 border border-white/10 text-[10px] font-black tracking-widest uppercase rounded text-center text-zinc-200 hover:text-[#F28C18] hover:border-[#F28C18]/40 transition-all">
              {dashboardLabel}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
